/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_NameInputs */

const vi_tea_grade_name = /** @type {(inputs: Tea_Grade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên loại`)
};

/**

* @param {Tea_Grade_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_name = /** @type {((inputs?: Tea_Grade_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_name(inputs)
});